import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import "components/app.scss";
import "components/common/react-data-grid.scss";
import { routes } from "./routes";

export const App = ({ store }) => (
  <Provider store={ store }>
    { routes }
  </Provider>
);

App.propTypes = {
  store: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/app.jsx